
import * as React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend, Brush } from 'recharts'
import { formatNumber } from 'src/share/utils/formatNumbers';
import { noData, style, styleNoData } from 'src/modules/Dashboard/Home/components/YearChart';

export const GAInsightsChart = (props) => {
  let data = props.data.map((d: any) => {
    d['Ad clicks'] = d.clicks;
    d['Google views'] = d.views;
    return d;
  })
  data = data.length > 0 ? data : noData;
  return (
    <>
      {data.length === 0 && <p>No Data to Show</p>}
      {data.length > 0 && <ResponsiveContainer width={'95%'} height={310}>
        <AreaChart height={400} data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="day" />
          <YAxis />
          <Tooltip content={<CustomTooltipInsights />} />
          {props.data.length > 0 && <Area type='monotone' dataKey='Ad clicks' stroke='#2ABCCA' fill='#2ABCCA' />}
          {props.data.length > 0 && <Area type='monotone' dataKey='Google views' stroke='#E2BC2F' fill='#E2BC2F' />}
          {props.data.length === 0 && <Area type='monotone' dataKey='No Data to Show' stroke='grey' fill='grey' />}
          <Legend iconSize={10} width={300} height={10} layout='horizontal' wrapperStyle={props.data.length > 0 ? style : styleNoData} />
          <Brush dataKey='day' height={30} stroke="#8884d8" />
        </AreaChart>
      </ResponsiveContainer>}
    </>
  )
}

export const CustomTooltipInsights = (props) => {
  const { active, payload } = props;
  if (active && payload && payload[0] && payload[1] && payload[0].payload && payload[1].payload) {
    return (
      <div className="custom-tooltip">
        <p><b>{payload[0].payload.day}</b></p>
        <p style={{ color: payload[0].color }}>{`Ad clicks: ${formatNumber(payload[0].payload.clicks || 0)}`}</p>
        <p style={{ color: payload[1].color }}>{`Google views: ${formatNumber(payload[1].payload.views || 0)}`}</p>
      </div>
    );
  }
  return null;
}
